<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Merchant Migration</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant migration for Participant Id: {{participantID}}</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div *ngIf="!!participant" class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="form-group row">
              <label for="ServiceType" class="col-3 col-form-label">Search merchants</label>
              <div class="col-9">
                <ng-select2 [(ngModel)]="MerchantNumber" [name]="merchantNumber" [ngModelOptions]="{standalone: true}"
                            [data]="merchantNumbers"
                            [options]="select2options" placeholder="Merchant number"></ng-select2>
              </div>
            </div>
            <div *ngIf="dataUnavailable">

              <div class="form-group row">
                <label for="merchantNumberId" class="col-3 col-form-label">Merchant Number: </label>
                <div class="col-9">
                  <input [(ngModel)]="merchantNumberId" id="merchantNumberId" [name]="merchantNumberId" placeholder="Merchant number" required class="form-control" maxlength="15" [ngModelOptions]="{standalone: true}">
                </div>
              </div>


              <div class="form-group row">
                <label for="cardAcceptorConfig" class="col-3 col-form-label">Merchant config</label>
                <div class="col-9">
                  <ng-select2 id="CardAcceptorConfigId" [ngModel]="CardAcceptorConfigId" [name]="CardAcceptorConfigId" [data]="cardAcceptorConfigs" [options]="select2options" [ngModelOptions]="{standalone: true}"></ng-select2>
                </div>
              </div>

              <div class="form-group row">
                <label for="postalServiceCode" class="col-3 col-form-label">Postal Service Code</label>
                <div class="col-9">
                  <input [(ngModel)]="postalServiceCode" id="postalServiceCode" [name]="postalServiceCode" class="form-control" maxlength="4" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="subMerchantId" class="col-3 col-form-label">Sub Merchant ID<i class="fe-info" placement="top" ngbTooltip="Client facing Merchant number for aggregator merchants, Please populate with 15 zeros for ISO merchants"></i></label>
                <div class="col-9">
                  <input [(ngModel)]="subMerchantId" id="subMerchantId" [name]="subMerchantId" class="form-control" maxlength="15" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="paymentFacilitatorId" class="col-3 col-form-label">Payment Facilitator ID<i class="fe-info" placement="top" ngbTooltip="PFID provided by bank when Aggregator after registered with VISA/MC"></i></label>
                <div class="col-9">
                  <input [(ngModel)]="paymentFacilitatorId" id="paymentFacilitatorId" [name]="paymentFacilitatorId" class="form-control" maxlength="11" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="paymentFacilitatorIdVisa" class="col-3 col-form-label">Payment Facilitator ID VISA</label>
                <div class="col-9">
                  <input [(ngModel)]="paymentFacilitatorIdVisa" id="paymentFacilitatorIdVisa" [name]="paymentFacilitatorIdVisa" class="form-control" maxlength="11" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="independentSalesOrganizationId" class="col-3 col-form-label">Independent Sales Organization ID   <i class="fe-info" placement="top" ngbTooltip="For ISO Merchants only this field should be populated with the same value as the Mastercard Payments Facilitator Details"></i></label>
                <div class="col-9">
                  <input [(ngModel)]="independentSalesOrganizationId" id="independentSalesOrganizationId" [name]="independentSalesOrganizationId" class="form-control" maxlength="11" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoContent">
                <label for="independentSalesOrganizationIdVisa" class="col-3 col-form-label">Independent Sales Organization ID VISA </label>
                <div class="col-9">
                  <input [(ngModel)]="independentSalesOrganizationIdVisa" id="independentSalesOrganizationIdVisa" [name]="independentSalesOrganizationIdVisa" class="form-control" maxlength="11" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="customerServicePhoneNo" class="col-3 col-form-label">Customer Service Phone No <i class="fe-info" placement="top" ngbTooltip="Customer Service Phone Number should start with '27' i.e 27721234567"></i></label>
                <div class="col-9">
                  <input [(ngModel)]="customerServicePhoneNo" id="customerServicePhoneNo" [name]="customerServicePhoneNo" class="form-control" minlength="11" maxlength="11" placeholder="" [ngModelOptions]="{standalone: true}">
                </div>
              </div>

              <div class="form-group row" *ngIf="displayIsoAndAggContent">
                <label for="merchantStreetAddress" class="col-3 col-form-label">Street Address   <i class="fe-info" placement="top" ngbTooltip="48 characters and space-filled. No special Characters such as '"></i></label>
                <div class="col-9">
                  <textarea rows="3" (keypress)="omit_special_char_for_address($event)" [name]="merchantStreetAddress" [(ngModel)]="merchantStreetAddress" class="form-control" id="merchantStreetAddress" maxlength="48" placeholder="Street Address" [ngModelOptions]="{standalone: true}"></textarea>
                </div>
              </div>


            </div>

            <hr />

            <div class="form-group row" offset-3 col-9 *ngIf="error">
              <div class="col-10">
                <p class="text-danger">{{errorMessage}}</p>
              </div>
            </div>


            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="RetrieveData()" [(disabled)]="disabledOption">
                  Retrieve data
                </button>
              </div>
            </div>
            <div class="form-group mb-0 justify-content-end row" *ngIf="save">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="SaveData()" [(disabled)]="disabledOption">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
